import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import download from '@/components/download'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path:'/download',
      name:'download',
      component:download
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js